import {WsInsuranceSortField} from '@lifeislife/lifeislife-ws-api';

export type InsuranceSortField = WsInsuranceSortField;
export const InsuranceSortField = WsInsuranceSortField;
